import { render } from "./FollowUpStatus.vue?vue&type=template&id=ea883716&scoped=true"
import script from "./FollowUpStatus.vue?vue&type=script&lang=js"
export * from "./FollowUpStatus.vue?vue&type=script&lang=js"

import "./FollowUpStatus.vue?vue&type=style&index=0&id=ea883716&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea883716"]])

export default __exports__